import { Navigate, useLocation } from "react-router-dom";
import { canAny, getRoles } from "./permissions";
import { tokenStore } from "../utils/tokenStore";

type ProtectedRouteProps = {
  children: React.ReactNode;
  requiredPerms?: string[];
  requiredRoles?: string[];
};

export default function ProtectedRoute({
  children,
  requiredPerms = [],
  requiredRoles = [],
}: ProtectedRouteProps) {
  const location = useLocation();
  const { token } = tokenStore.get();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // check roles
  if (requiredRoles.length > 0) {
    const roles = getRoles();
    const ok = requiredRoles.some((r) => roles.includes(r));
    if (!ok) return <Navigate to="/schedule" replace />;
  }

  if (requiredPerms.length > 0 && !canAny(requiredPerms)) {
    return <Navigate to="/schedule" replace />;
  }

  return <>{children}</>;
}